export default __webpack_public_path__ + "static/media/videoconf.0049bf95.jpg";